module.exports = __webpack_public_path__ + "static/media/22.e0012944.jpg";